
function GetPosts(paginaVoluta) {
    try {

        waitingBS.Show();

        var params = {
            pagina: paginaVoluta
        };

        $.ajax({
            url: '/Editoriale/GetElencoPost',
            type: "POST",
            data: params,
            success: function (data) {
                $('#PostResults').html(data);
                scrollTo(0, 0);
                waitingBS.Hide();
            },
            error: function (xhr, status, error) {
                console.log(error);
                console.log(status);
                console.log(xhr);
                waitingBS.Hide();
            }
        });

    } catch (err) {
        console.log(err);
        waitingBS.Hide();
    }
}